module.exports = __webpack_public_path__ + "static/media/bank.76068e36.png";